import React from 'react';
import { Redirect } from 'react-router-dom';
import { Query } from 'react-apollo';
import { get } from 'lodash';
import { toast } from 'react-toastify';

import { USER } from '../graphql/query';
import { logout } from '../utils';

export default (Component, isRequireAuth = true) => props => {
  return (
    <Query query={USER} fetchPolicy="network-only">
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) {
          toast.error('Server unavailable.');
        }
        const user = get(data, 'me');
        const role = get(user, 'role');
        if (isRequireAuth && !user) {
          return <Redirect to="/login" />;
        } else if (!isRequireAuth && user) {
          return <Redirect to="/users" />;
        }
        if (isRequireAuth && role !== 'SYSTEM_ADMIN') {
          logout();
        } else {
          return <Component {...props} />;
        }
      }}
    </Query>
  );
};



// WEBPACK FOOTER //
// ./src/auth/requireAuthentication.js